type CheckClientResponse {
  found: Boolean!
}
